import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "pricingVariable"
const PricingVariableIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m15.225 7.5 1.631 1.574-3.477 3.355-2.849-2.75-5.28 5.102 1.004.969 4.276-4.125 2.85 2.75 4.488-4.324 1.632 1.574V7.5h-4.275ZM12 24C5.372 24 0 18.627 0 12S5.372 0 12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12Z"
          />
        </svg>
      }
    </span>
  )
}
export default PricingVariableIcon
